import { ActorName, Card, KeyValue } from '../../../ui/misc';
import { Timestamp } from '../../../ui/Timestamp';
import type { ReleaseDetail } from '../types';

export function History({ r }: { r: ReleaseDetail }) {
  return (
    <Card title="History" tight>
      <KeyValue
        items={[
          ['Created', <Timestamp key="c" value={r.createdAt} />],
          ['By', <ActorName key="b" actor={r.createdBy} />],
          [
            'Candidates',
            r.candidateHistory
              .map((c) => `#${c.number} ${c.sourceRevision?.slice(0, 8) ?? 'not frozen'}`)
              .join(', '),
          ],
        ]}
      />
    </Card>
  );
}
